// Generated by CoffeeScript 2.7.0
var LogicalRatingMixin;

export default LogicalRatingMixin = {
  methods: {
    debouncedHandleLogic: function() {
      var value;
      if (this.visible) {
        if (this.logical) {
          this.currentHittedFieldIds = [];
          value = this.value;
          return _.each(this.field.logic_rule, (raw_judgement) => {
            if (Skylark.App.Judgement.validate(value, raw_judgement)) {
              return this.currentHittedFieldIds = _.union(this.currentHittedFieldIds, raw_judgement.field_ids);
            }
          });
        }
      } else {
        return this._clearValue();
      }
    }
  }
};
